import { message } from 'antd';
import type { UploadProps } from 'antd/lib/upload';

import { getTranslatedString } from '@/utils/intl';

import { isPdfName } from '../upload-queue';

// No `accept` prop on purpose. rc-upload silently filters drag-dropped
// files by `accept` *before* calling `beforeUpload` (see rc-upload's
// AjaxUploader.onFileDrop), so a .txt drop would vanish without any
// toast or row in the table — the operator just sees "nothing happened".
// Letting every file reach `beforeUpload` makes the explicit
// "PDF files only" toast actually fire. The file-picker path goes
// through the same check, so behavior stays consistent across both.
export const pdfDraggerProps: UploadProps = {
  name: 'file',
  multiple: true,
  showUploadList: false,
  customRequest: () => undefined,
};

export const acceptPdfOrWarn = (file: File): boolean => {
  if (isPdfName(file.name)) return true;
  message.error(getTranslatedString('waybills.imports.upload.invalid-type'));
  return false;
};
